.marketing-banner {
  background-color: #e6e6e6;
  border: 1px solid #cbcbcb;
  padding: 20px;
  display: flex;
  column-gap: 36px;
  margin-top: 30px;
  align-items: center;
  justify-content: space-between;
}

.marketing-banner-content {
  display: flex;
  column-gap: 12px;
  align-items: center;
}

.marketing-banner-text-container {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  max-width: 934px;
}

.marketing-banner-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 24px;
}

.marketing-banner-description {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.banner-icon {
  color: #000000;
  width: 32px;
  height: 32px;
}

.icon-container {
  min-width: 52px;
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.marketing-products-tab__button {
  font-size: 16px;
  font-weight: 700;
}

@media screen and (max-width: 979px) {
  .marketing-banner {
    flex-direction: column;
    column-gap: 0;
    row-gap: 32px;
    margin-top: 20px;
  }

  .marketing-products-tab__button {
    width: 100%;
  }

  .marketing-banner-text-container {
    row-gap: 16px;
    max-width: none;
  }

  .icon-container {
    display: none;
  }
}